<!--  -->
<template>
  <div>
    <div style="padding: 0px 20px;margin-top: 20px;">
      <div class="tab-nav">
        <div
          v-for="item in navList"
          :key="item.value"
          class="tab-item"
          :class="{ active: typelist === item.value }"
          @click="tuilink(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <div class="add_box">
      <!-- <div class="left_box">
      <el-button type="primary" style="margin-bottom: 10px;" @click="tuilink(1)">推广链接</el-button>
      <el-button type="success" style="margin-left: 0px;margin-bottom: 10px;" @click="tuilink(2)">推广用户</el-button>
      <el-button type="warning" style="margin-left: 0px;" @click="tuilink(3)">回传记录</el-button>
    </div> -->

      <div v-if="typelist == 1" class="right_box">
        <div class="search_box">
          <div class="search_box">
            <el-input
              v-model="objr.keywords"
              style="width:300px;"
              placeholder="请输入"
            />
            <el-select
              v-model="objr.onlyMe"
              :disabled="true"
              placeholder="请选择"
              style="width:300px;"
            >
              <el-option
                v-for="item in accountarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-select
              v-model="objr.default_a"
              placeholder="请选择"
              style="width:300px;"
            >
              <el-option
                v-for="item in defaultarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              type="primary"
              style=""
              icon="el-icon-search"
              @click="sraw"
            >搜索</el-button>
            <el-button
              type="info"
              icon="el-icon-refresh-right"
              @click="awered"
            >重置</el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="handleBatchDelete"
            >删除</el-button>
          </div>
          <div>
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="addbit"
            >添加</el-button>
          </div>
        </div>

        <!-- <el-button type="primary" @click="awered">重置</el-button> -->
        <el-table
          :key="typelist"
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%;margin-top:20px"
          max-height="800"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          />
          <el-table-column
            prop="title"
            label="标题"
            width="130"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.title }}
              <i
                v-clipboard:copy="formatCopy(scope.row)"
                v-clipboard:success="onCopys"
                v-clipboard:error="onErrors"
                class="el-icon-document-copy"
                style="color: #165DFF; border: 0; font-size: 14px; cursor: pointer;"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="corp_name"
            label="企业名称"
            width="150"
            align="center"
          />
          <el-table-column
            prop="wx_url"
            label="获客链接"
            width="300"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.wx_url }}
              <i
                v-if="scope.row.wx_url!=''"
                v-clipboard:success="onCopysr"
                v-clipboard:error="onErrorsr"
                v-clipboard:copy="scope.row.wx_url"
                class="el-icon-document-copy"
                style="color: #165DFF;border: 0;font-size: 14px;cursor: pointer;"
              />
            </template>
          </el-table-column> -->
          <!-- <el-table-column
        prop="send_text"
        label="发送内容"
        width="200"
        align="center"
      /> -->
          <el-table-column
            prop="iqiyi_promotion_link_no"
            label="编号"
            width="200"
            align="center"
          />
          <!-- <el-table-column
            prop="app_id"
            label="小程序appid"
            width="260"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.app_id }}（{{ scope.row.account_name }}）<span v-if="scope.row.operation_status!=1" style="color: #F56C6C;">（{{ scope.row.operation_status_text }}）</span><el-button type="primary" size="mini" @click="lookdata(scope.row)">页面数据</el-button>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="app_id"
            label="小程序appid"
            width="320"
            align="center"
          >
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; justify-content: center; gap: 6px; flex-wrap: wrap;">
                <span>
                  {{ scope.row.app_id }}（{{ scope.row.account_name }}）
                  <span
                    v-if="scope.row.operation_status != 1"
                    style="color: #F56C6C;"
                  >
                    ({{ scope.row.operation_status_text }})
                  </span>
                </span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="lookdata(scope.row)"
                >
                  页面数据
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="page_path"
            label="内推链接"
            width="400"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.action_sets && scope.row.action_sets.length > 0" style="position: relative; min-height: 60px; padding-bottom: 28px;">
                <div style="margin-bottom: 8px; word-break: break-all;">{{ getActionSetLink(scope.row, 0) }}</div>
                <div style="position: absolute; bottom: 0; left: 0; right: 0; display: flex; gap: 4px;">
                  <el-button
                    v-if="scope.row.action_sets.length > 1"
                    type="primary"
                    size="mini"
                    style="flex: 1; width: 50%;"
                    @click="openActionSetsDialog(scope.row)"
                  >
                    更多
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    :style="scope.row.action_sets.length > 1 ? 'flex: 1; width: 50%;' : 'width: 100%;'"
                    @click="copyToClipboard(getActionSetLink(scope.row, 0))"
                  >
                    复制
                  </el-button>
                </div>
              </div>
              <div v-else style="text-align: center;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="openSetDataSource(scope.row)"
                >
                  设置数据源
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="url_link"
            label="外推链接"
            width="250"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.url_link }}
              <i
                v-if="scope.row.url_link!=''"
                v-clipboard:success="onCopys"
                v-clipboard:error="onErrors"
                v-clipboard:copy="scope.row.url_link"
                class="el-icon-document-copy"
                style="color: #165DFF;border: 0;font-size: 14px;cursor: pointer;"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="default_a"
            label="默认A页"
            align="center"
            width="70"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.default_a"
                :active-value="2"
                :inactive-value="1"
                active-color="#13ce66"
                @change="unBindStatusUpdate($event,scope.row)"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="button_text"
            label="按钮文字"
            width="150"
            align="center"
          />
          <el-table-column
            prop="button_title_text"
            label="按钮标题"
            width="150"
            align="center"
          />
          <el-table-column
            prop="button_introduction_text"
            label="按钮简介"
            width="150"
            align="center"
          /> -->
          <!-- <el-table-column
        prop="expire_time_text"
        label="企业员工"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          <div
            v-for="item,index in scope.row.employee"
            :key="index"
          >{{ item }}</div>
        </template>
      </el-table-column> -->

          <!-- <el-table-column
            prop="expire_time_text"
            label="企业员工"
            width="300"
            align="center"
          >
            <template slot-scope="scope">
              <div
                class="employee-list"
                :title="scope.row.employee.join('，')"
              >
                <div
                  v-for="(item, index) in scope.row.employee"
                  :key="index"
                  class="employee-item"
                >
                  {{ item }}
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="created_at_text"
            label="创建时间"
            align="center"
            width="200"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">

              <el-button
                type="text"
                style="margin-bottom:10px;color:#165dff;"
                @click="getDelayedMsg(scope.row)"
              >延时消息</el-button>
              <el-button
                type="text"
                style="margin-bottom:10px;color: #13ce66;"
                @click="exportledit(scope.row)"
              >修改</el-button>
              <el-button
                type="text"
                style="margin-bottom:10px;color: #e6a23c;"
                @click="reusedawrq(scope.row)"
              >复用</el-button>
              <!-- <el-button
                type="text"
                style="margin-bottom:10px;color: #165dff;"
                @click="lookdianji(scope.row.iqiyi_promotion_link_no)"
              >点击记录</el-button> -->
              <el-button
                type="text"
                style="margin-bottom:10px;color: #f78989;"
                @click="exportlisrwdaw(scope.row.iqiyi_promotion_link_no)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- <pagination-right
          ref="paginationbox"
          :current-page="objr.page"
          :page-sizes="[10,30,50,100]"
          :total="newtotalr"
          @size-change="fetchPageSizer($event)"
          @current-change="fetchCurrentPager"
        /> -->
        <el-pagination
          style="text-align: right;margin-top: 10px;"
          background
          :current-page="objr.page"
          :page-size="objr.pageSize"
          :page-sizes="[10, 30, 50, 100]"
          :total="newtotalr"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchPageSizer"
          @current-change="fetchCurrentPager"
        />

      </div>
      <div v-if="typelist == 2" class="right_box">
        <div class="search_box">
          <div class="search_box">
            <el-input
              v-model="objrr.iqiyi_promotion_link_no"
              style="width:300px;"
              placeholder="请输入编号"
            />
            <el-input
              v-model="objrr.app_id"
              style="width:300px;"
              placeholder="请输入appid"
            />
            <el-input
              v-model="objrr.advertiser_id"
              style="width:300px;"
              placeholder="请输入广告主id"
            />
            <el-select
              v-model="objrr.user_source"
              placeholder="请选择"
              style="width:300px;"
            >
              <el-option
                v-for="(itemr, index) in accountarrrr"
                :key="itemr.valuer + '-' + index"
                :label="itemr.label"
                :value="itemr.valuer"
              />
            </el-select>
            <el-select
              v-model="objrr.match_monitoring_link"
              placeholder="请选择"
              style="width:300px;"
            >
              <el-option
                v-for="(itemr, index) in accoulist"
                :key="itemr.value + '-' + index"
                :label="itemr.label"
                :value="itemr.value"
              />
            </el-select>
            <el-button
              type="primary"
              style=""
              icon="el-icon-search"
              @click="srawrr"
            >搜索</el-button>
            <el-button
              type="info"
              icon="el-icon-refresh-right"
              @click="aweredrr"
            >重置</el-button>
          </div>
        </div>
        <el-table
          :key="typelist"
          v-loading="loadingrr"
          :data="tableDatalist"
          border
          style="width: 100%;margin-top:20px"
        >
          <el-table-column
            prop="iqiyi_promotion_link_no"
            label="标题（编号）"
            width="400"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.promotion_link_title }} （{{ scope.row.iqiyi_promotion_link_no }}）
            </template>
          </el-table-column>
          <el-table-column
            prop="app_id"
            label="小程序名称（appId）"
            width="300"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.account_name }} （{{ scope.row.app_id }}）
            </template>
          </el-table-column>
          <el-table-column
            prop="advertiser_id"
            label="广告主id"
            width="300"
            align="center"
          />
          <el-table-column
            prop="app_id"
            label="是否匹配监测链接"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.match_monitoring_link == true">是</div>
              <div v-if="scope.row.match_monitoring_link == false">否</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_source_text"
            label="用户来源"
            width="200"
            align="center"
          />
          <el-table-column
            prop="created_at_text"
            label="创建时间"
            width="200"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                style="margin-bottom:10px;color:#165dff;"
                @click="chuandaw(scope.row)"
              >回传</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          ref="paginationbox"
          :current-page="objrr.page"
          :page-sizes="[10]"
          :total="newtotalrtotal"
          @size-change="fetchPageSizerrr($event)"
          @current-change="fetchCurrentPagerrr"
        />
      </div>
      <div v-if="typelist == 3" class="right_box">
        <div class="search_box">
          <div class="search_box">
            <el-input
              v-model="newobj.iqiyi_promotion_link_no"
              style="width:300px;"
              placeholder="请输入编号"
            />
            <el-input
              v-model="newobj.app_id"
              style="width:300px;"
              placeholder="请输入appid"
            />
            <el-button
              type="primary"
              style=""
              icon="el-icon-search"
              @click="srawrrr"
            >搜索</el-button>
            <el-button
              type="info"
              icon="el-icon-refresh-right"
              @click="aweredrrr"
            >重置</el-button>
          </div>
        </div>
        <el-table
          :key="typelist"
          v-loading="newloading"
          :data="newtable"
          border
          style="width: 100%;margin-top:20px"
        >
          <el-table-column
            prop="iqiyi_promotion_link_no"
            label="标题（编号）"
            width="400"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.promotion_link_title }} （{{ scope.row.iqiyi_promotion_link_no }}）
            </template>
          </el-table-column>
          <el-table-column
            prop="app_id"
            label="小程序名称（appId）"
            width="300"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.account_name }} （{{ scope.row.app_id }}）
            </template>
          </el-table-column>
          <el-table-column
            prop="event_type"
            label="类型"
            align="center"
            width="200"
          />
          <el-table-column
            prop="status_text"
            label="回传结果"
            align="center"
            width="200"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            width="300"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="created_at_text"
            label="创建时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="admin_name"
            label="管理员"
            align="center"
          />
        </el-table>
        <pagination-right
          ref="paginationbox"
          :current-page="newobj.page"
          :page-sizes="[10]"
          :total="newtital"
          @size-change="fetchPageSizerrrr($event)"
          @current-change="fetchCurrentPagerrrr"
        />
      </div>
      <div v-if="typelist == 4" class="right_box">
        <div class="search_box">
          <div class="search_box">
            <el-input
              v-model="objnum.iqiyi_promotion_link_no"
              style="width:300px;"
              placeholder="请输入编号/标题"
            />
            <el-input
              v-model="objnum.app_id"
              style="width:300px;"
              placeholder="请输入appid/小程序名称"
            />
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              unlink-panels
              :picker-options="pickerOptions"
              :clearable="false"
            />
            <el-button
              type="primary"
              style=""
              icon="el-icon-search"
              @click="srawoner"
            >搜索</el-button>
            <el-button
              type="info"
              icon="el-icon-refresh-right"
              @click="aweredoner"
            >重置</el-button>
            <el-tag type="warning" style="margin-left: 20px;">链接点击总数：{{ click_count }}</el-tag>
          </div>
        </div>
        <el-table
          :data="newtablredata"
          border
          stripe
          style="width: 100%;margin-top: 20px;"
        >
          <el-table-column prop="title" label="标题" align="center" />
          <el-table-column prop="iqiyi_promotion_link_no" label="编号" align="center" />
          <el-table-column
            prop="app_id"
            label="小程序appid"
            width="400"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.app_id }}（{{ scope.row.account_name }}）
            </template>
          </el-table-column>
          <el-table-column prop="click_date_text" label="统计时间" align="center" />
          <el-table-column prop="click_number" label="点击次数" align="center" />
        </el-table>
        <pagination-right
          ref="paginationboxmer"
          :current-page="objnum.page"
          :page-sizes="[10]"
          :total="objtotal"
          @size-change="fetchPageSizerpoi($event)"
          @current-change="fetchCurrentPagerpoi"
        />
      </div>
      <div v-if="typelist == 5" class="right_box">
        <div class="search_box">
          <div class="search_box">
            <el-input
              v-model="configSearch.app_id"
              style="width:300px;"
              placeholder="请输入appid"
            />
            <el-input
              v-model="configSearch.user_action_set_id"
              style="width:300px;"
              placeholder="请输入数据源ID"
              clearable
              @keyup.enter.native="loadConfigList"
            />
            <el-button
              type="primary"
              style=""
              icon="el-icon-search"
              @click="loadConfigList"
            >搜索</el-button>
            <el-button
              type="info"
              icon="el-icon-refresh-right"
              @click="resetConfigPage"
            >重置</el-button>
            <el-button
              type="success"
              icon="el-icon-refresh"
              @click="openSyncDialog"
            >同步数据源</el-button>
          </div>
        </div>

        <!-- 列表 -->
        <el-table v-loading="globalLoading" :data="configList" border style="width:100%;margin-top:20px;">
          <el-table-column prop="app_id" label="小程序Appid/名称" align="center" width="300">
            <template slot-scope="scope">
              {{ scope.row.app_id_str }}（{{ scope.row.official_account_name }}）
            </template>
          </el-table-column>
          <el-table-column prop="account_id" label="广告主名称/ID" align="center">
            <template slot-scope="scope">
              {{ scope.row.account_name }}({{ scope.row.account_id }})
            </template>
          </el-table-column>
          <el-table-column prop="name" label="数据源名称" align="center" />
          <el-table-column prop="user_action_set_id" label="数据源ID" align="center" />
          <el-table-column prop="secret_key" label="SecretKey" align="center" />
          <el-table-column prop="hk_default" align="center" width="120">
            <template slot="header">
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="white-space: pre-line;">
                  默认数据源什么时候生效

                  1、推广链接未绑定数据源时，会根据小程序appid关联上默认的记录

                  2、推广链接已经绑定了数据源，数据源被停用时。
                </div>
                <span style="cursor: pointer; display: inline-flex; align-items: center; gap: 4px;">
                  是否默认
                  <i class="el-icon-question" style="color: #909399;" />
                </span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.hk_default"
                :active-value="2"
                :inactive-value="1"
                active-color="#13ce66"
                @change="handleHkDefaultChange($event, scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="hk_status" align="center" width="120">
            <template slot="header">
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="white-space: pre-line;">
                  已经在投的数据源停用后将会使用默认的
                </div>
                <span style="cursor: pointer; display: inline-flex; align-items: center; gap: 4px;">
                  状态
                  <i class="el-icon-question" style="color: #909399;" />
                </span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.hk_status"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                @change="handleHkStatusChange($event, scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" style="color:#165dff;" @click="openUpdateSecret(scope.row)">更新SecretKey<span v-if="scope.row.secret_key==''" style="color: red;">（请及时更新）</span></el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页器 -->
        <pagination-right
          ref="configPagination"
          :current-page="configSearch.page"
          :page-sizes="[10,20,50]"
          :total="configTotal"
          @size-change="changeConfigPageSize"
          @current-change="changeConfigPage"
        />
      </div>
      <el-dialog
        title="推广链接"
        :visible.sync="dialogVisible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        wdith="990px"
      >
        <activation
          ref="activationview"
          @updata="updata"
        />
      </el-dialog>
      <el-dialog
        title="延时消息"
        :visible.sync="delayedMsgVisible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        wdith="990px"
      >
        <ded-msg-list
          ref="ded_msg_list"
        />
      </el-dialog>
      <el-dialog
        title="回传行为"
        :visible.sync="dialogTransferVisible"
        :close-on-click-modal="false"
        width="500px"
      >
        <div>
          <!-- <el-select
            v-model="selectedPlatform"
            placeholder="请选择平台"
            style="width: 300px"
          >
            <el-option
              v-for="(item, index) in platformOptions"
              :key="item.event_type + '-' + index"
              :label="item.event_type_name"
              :value="item.event_type"
            />
          </el-select> -->
          <el-form :model="form">
            <!-- 下拉菜单选择事件 -->
            <el-form-item label="回传行为">
              <el-select v-model="form.event_type" placeholder="请选择回传行为" @change="handleEventChange">
                <el-option
                  v-for="item in typeList"
                  :key="item.event_type"
                  :label="item.event_type_name"
                  :value="item.event_type"
                />
              </el-select>
            </el-form-item>

            <!-- 动态渲染 properties 输入框 -->
            <el-form-item
              v-for="prop in selectedProperties"
              :key="prop.properties_key"
              :label="prop.properties_name"
            >
              <el-input
                v-model="form.properties[prop.properties_key]"
                :placeholder="prop.properties_tips || '请输入内容'"
              />
            </el-form-item>
          </el-form>

          <!-- 调试输出 -->
          <!-- <pre>{{ form }}</pre> -->
        </div>
        <div style="margin-top: 20px;">
          <el-button type="primary" @click="submitTransfer">提交</el-button>
          <el-button @click="dialogTransferVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="内推链接"
        :visible.sync="actionSetsDialogVisible"
        :close-on-click-modal="false"
        width="70%"
      >
        <!-- 列表 -->
        <el-table :data="paginatedActionSets" border style="width:100%;margin-bottom:10px;">
          <el-table-column label="广告主ID/名称" align="center">
            <template slot-scope="scope">
              {{ scope.row.account_name }}({{ scope.row.account_id }})
            </template>
          </el-table-column>
          <el-table-column label="数据源ID/名称" align="center">
            <template slot-scope="scope">
              {{ scope.row.name }}({{ scope.row.user_action_set_id }})
            </template>
          </el-table-column>
          <el-table-column label="内推链接" align="center">
            <template slot-scope="scope">
              <span>
                {{ getActionSetLinkForDialog(scope.row) }}
                <i
                  v-clipboard:copy="getActionSetLinkForDialog(scope.row)"
                  v-clipboard:success="onCopys"
                  v-clipboard:error="onErrors"
                  class="el-icon-document-copy"
                  style="color: #165DFF; border: 0; font-size: 14px; cursor: pointer; margin-left:6px;"
                />
              </span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页器 -->
        <pagination-right
          ref="actionSetsPagination"
          :current-page="actionSetsPage"
          :page-sizes="[10,20,50]"
          :total="actionSetsTotal"
          @size-change="changeActionSetsPageSize"
          @current-change="changeActionSetsPage"
        />
      </el-dialog>
      <el-dialog
        title="内推链接"
        :visible.sync="configDialogVisible"
        :close-on-click-modal="false"
        width="70%"
      >
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:25px;">
          <!-- <span>内推链接 : {{ currentPagePath }}</span> -->
          <!-- <i
            v-if="currentPagePath"
            v-clipboard:copy="currentPagePath"
            v-clipboard:success="onCopys"
            v-clipboard:error="onErrors"
            class="el-icon-document-copy"
            style="color: #165DFF; border: 0; font-size: 14px; cursor: pointer;"
          /> -->
        </div>
        <!-- 顶部搜索与同步 -->
        <div style="display:flex; justify-content:space-between; margin-bottom:10px;">
          <div>
            <el-input
              v-model="configSearch.user_action_set_id"
              placeholder="请输入数据源ID"
              clearable
              style="width:260px; margin-right:10px;"
              @keyup.enter.native="loadConfigList"
            />
            <el-button type="primary" @click="loadConfigList">搜索</el-button>
            <el-button type="info" @click="resetConfig">重置</el-button>
          </div>
          <el-button type="success" @click="openSyncDialog">同步数据源</el-button>
        </div>

        <!-- 列表 -->
        <el-table v-loading="globalLoading" :data="configList" border style="width:100%;margin-bottom:10px;">
          <el-table-column prop="account_id" label="广告主名称/ID" align="center">
            <template slot-scope="scope">
              {{ scope.row.account_name }}({{ scope.row.account_id }})
            </template>
          </el-table-column>
          <!-- <el-table-column prop="user_action_set_id" label="数据源ID" align="center" /> -->
          <el-table-column prop="name" label="数据源名称" align="center" />
          <!-- <el-table-column prop="secret_key" label="SecretKey" align="center" /> -->
          <el-table-column label="推广链接" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.secret_key">
                {{ currentPagePath }}&user_action_set_id={{ scope.row.user_action_set_id }}
                <i
                  v-clipboard:copy="`${currentPagePath}&user_action_set_id=${scope.row.user_action_set_id}`"
                  v-clipboard:success="onCopys"
                  v-clipboard:error="onErrors"
                  class="el-icon-document-copy"
                  style="color: #165DFF; border: 0; font-size: 14px; cursor: pointer; margin-left:6px;"
                />
              </span>
            </template>
          </el-table-column>

          <!-- <el-table-column label="外推" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.secret_key">
              </span>
            </template>
          </el-table-column> -->

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" style="color:#165dff;" @click="openUpdateSecret(scope.row)">更新SecretKey<span v-if="scope.row.secret_key==''" style="color: red;">（请及时更新）</span></el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页器 -->
        <pagination-right
          ref="configPagination"
          :current-page="configSearch.page"
          :page-sizes="[10,20,50]"
          :total="configTotal"
          @size-change="changeConfigPageSize"
          @current-change="changeConfigPage"
        />
      </el-dialog>
      <el-dialog
        title="同步配置"
        :visible.sync="syncDialogVisible"
        width="500px"
      >
        <el-input v-model="syncInput" placeholder="请输入广告主ID" style="margin-bottom:20px;" />
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeSyncDialog">取消</el-button>
          <el-button type="primary" @click="confirmSync">确定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="更新 SecretKey"
        :visible.sync="updateSecretDialogVisible"
        width="500px"
      >
        <el-input
          v-model="updateSecret.secret_key"
          placeholder="请输入SecretKey"
          style="margin-bottom:20px;"
        />
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeUpdateSecret">取消</el-button>
          <el-button type="primary" @click="submitUpdateSecret">确定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { adDataSource, syncData, updateSecretKey, updateHkStatus, updateHkDefault, iqiyipromotionlinklist, iqiyipromotionlinkdel, iqiyilinkuserlist, oceanengineeventtype, oceanengineback, oceanenginerecord } from '@/api/officialaccount.js'
import activation from './components/activation.vue'
import DedMsgList from '@/views/miniservice/components/dedMsgList.vue'
import { officialAccountpageDataStatisticslist, kiadwertwqw } from '@/api/reportExamine.js'
export default {
  components: {
    DedMsgList,
    PaginationRight,
    activation
  },
  data() {
    return {
      dialogVisible: false,
      delayedMsgVisible: false,
      objr: {
        page: 1,
        pageSize: 10,
        keywords: null,
        onlyMe: 2,
        default_a: 0
      },
      objrr: {
        page: 1,
        pageSize: 10,
        user_source: 0,
        iqiyi_promotion_link_no: '',
        app_id: '',
        advertiser_id: '',
        match_monitoring_link: 0
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      dialogtransfer: false,
      loading: false,
      accountarr: [
        {
          value: 1,
          label: '查看组内推广链接'
        },
        {
          value: 2,
          label: '我关联的推广链接'
        }
      ],
      defaultarr: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '非默认页面'
        },
        {
          value: 2,
          label: '默认页'
        }
      ],
      accountarrrr: [
        {
          valuer: 0,
          label: '广告来源（全部）'
        },
        {
          valuer: 1,
          label: '巨量'
        },
        {
          valuer: 2,
          label: '腾讯'
        },
        {
          valuer: 2,
          label: '爱奇艺'
        }
      ],
      typelist: 1,
      newtotalrtotal: null,
      tableDatalist: [],
      platformOptions: [],
      selectedPlatform: null,
      dialogTransferVisible: false,
      open_id: '',
      loadingrr: false,
      newtable: [],
      newtital: null,
      newloading: false,
      newobj: {
        page: 1,
        pageSize: 10,
        app_id: ''
      },
      navList: [
        { label: '推广链接', value: 1 },
        { label: '推广用户', value: 2 },
        { label: '回传记录', value: 3 },
        { label: '点击记录', value: 4 },
        { label: '数据源', value: 5 }
      ],
      // 表单数据
      form: {
        event_type: '',
        properties: {}
      },
      // 当前选中的事件类型下的属性列表
      selectedProperties: [],
      typeList: [],
      accoulist: [
        { label: '检测链接（全部）', value: 0 },
        { label: '未匹配', value: 1 },
        { label: '已匹配', value: 2 }
      ],
      dateRange: [],
      pickerOptions: {
        disabledDate(time) {
          // 禁止选择今天之后的日期
          return time.getTime() > Date.now()
        }
      },
      objnum: {
        page: 1,
        pageSize: 10,
        iqiyi_promotion_link_no: '',
        app_id: ''
      },
      objtotal: null,
      newtablredata: [],
      click_count: null,
      configDialogVisible: false,
      configList: [],
      configTotal: 0,
      configSearch: {
        app_id: '',
        keyword: '',
        user_action_set_id: '',
        page: 1,
        pageSize: 10
      },
      currentPagePath: '',
      globalLoading: false,

      syncDialogVisible: false,
      syncInput: '',
      // action_sets 弹窗相关
      actionSetsDialogVisible: false,
      currentActionSetsRow: null,
      actionSetsPage: 1,
      actionSetsPageSize: 10,

      updateSecretDialogVisible: false,
      updateSecret: {
        account_id: '',
        user_action_set_id: '',
        secret_key: ''
      },
      // 多选选中的行
      multipleSelection: []

    }
  },
  computed: {
    // 分页后的 action_sets
    paginatedActionSets() {
      if (!this.currentActionSetsRow || !this.currentActionSetsRow.action_sets) {
        return []
      }
      const start = (this.actionSetsPage - 1) * this.actionSetsPageSize
      const end = start + this.actionSetsPageSize
      return this.currentActionSetsRow.action_sets.slice(start, end)
    },
    // action_sets 总数
    actionSetsTotal() {
      if (!this.currentActionSetsRow || !this.currentActionSetsRow.action_sets) {
        return 0
      }
      return this.currentActionSetsRow.action_sets.length
    }
  },
  created() {
    this.menuList()
  },
  mounted() {},
  methods: {
    transfer(row) {
      this.dialogtransfer = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.dialogtransfer.sendr(row)
      }, 100)
    },
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await iqiyipromotionlinklist(this.objr)
      console.log('data', data)
      this.tableData = []
      this.tableData = data.data.list
      this.newtotalr = data.data.total
      this.loading = false
    },
    sraw() {
      this.objr.page = 1
      // this.objr.page_size = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      // this.objr.page_size = 10
      this.objr.keywords = null
      this.objr.onlyMe = 2
      this.objr.default_a = 0
      this.menuList()
    },
    srawrr() {
      this.objrr.page = 1
      this.menuListtwo()
    },
    aweredrr() {
      this.objrr.page = 1
      this.objrr.user_source = 0
      this.objrr.iqiyi_promotion_link_no = ''
      this.objrr.app_id = ''
      this.objrr.advertiser_id = ''
      this.objrr.match_monitoring_link = 0
      this.menuListtwo()
    },
    srawrrr() {
      this.newobj.page = 1
      this.menuListthree()
    },
    aweredrrr() {
      this.newobj.page = 1
      this.newobj.iqiyi_promotion_link_no = ''
      this.newobj.app_id = ''
      this.menuListthree()
    },
    addbit() {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.activationview.send(1)
      }, 100)
    },
    exportledit(item) {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.activationview.send(2, item)
      }, 100)
    },
    getDelayedMsg(item) {
      this.delayedMsgVisible = true
      setTimeout(() => {
        // // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.ded_msg_list.send(item)
      }, 100)
    },
    reusedawrq(item) {
      this.$confirm('确定要复用吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          this.dialogVisible = true
          setTimeout(() => {
            // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.activationview.send(3, item)
          }, 100)
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.objr.page = 1
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    // 分页
    fetchPageSizerrr(e) {
      this.objrr.page_size = e
      this.menuListtwo()
    },
    fetchCurrentPagerrr(e) {
      this.objrr.page = e
      this.menuListtwo()
    },
    // 分页
    fetchPageSizerrrr(e) {
      this.newobj.page_size = e
      this.menuListthree()
    },
    fetchCurrentPagerrrr(e) {
      this.newobj.page = e
      this.menuListthree()
    },
    updata() {
      this.dialogVisible = false
      this.menuList()
    },
    async exportlisrwdaw(id) {
      console.log('item', id)
      this.$confirm('确定要删除吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          console.log('666')
          iqiyipromotionlinkdel({
            iqiyi_promotion_link_nos: [id]
          }).then(res => {
            console.log('res', res)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.menuList()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    onCopys() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    copyToClipboard(text) {
      // 创建临时文本区域
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      } catch (err) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(textarea)
    },
    onErrors() {
      this.$message.error('复制失败')
    },
    async menuListtwo() {
      // 获取列表
      this.loadingrr = true
      const data = await iqiyilinkuserlist(this.objrr)
      console.log('data', data)
      this.loadingrr = false
      this.tableDatalist = []
      this.tableDatalist = data.data.list
      this.newtotalrtotal = data.data.total
    },
    async menuListthree() {
      // 获取列表
      this.newloading = true
      const data = await oceanenginerecord(this.newobj)
      console.log('data', data)
      this.newloading = false
      this.newtable = []
      this.newtable = data.data.list
      this.newtital = data.data.total
    },
    tuilink(type) {
      this.typelist = type
      // eslint-disable-next-line eqeqeq
      if (this.typelist == 1) {
        this.menuList()
      // eslint-disable-next-line eqeqeq
      } else if (this.typelist == 2) {
        this.menuListtwo()
      // eslint-disable-next-line eqeqeq
      } else if (this.typelist == 3) {
        console.log('消息记录')
        this.menuListthree()
      // eslint-disable-next-line eqeqeq
      } else if (this.typelist == 4) {
        this.neawrlist()
      // eslint-disable-next-line eqeqeq
      } else if (this.typelist == 5) {
        this.loadConfigList()
      }
    },
    chuandaw(item) {
      console.log('item', item)
      this.open_id = item.open_id
      oceanengineeventtype().then((res) => {
        console.log('res', res.data)
        this.dialogTransferVisible = true
        // this.platformOptions = res.data.type_list
        this.typeList = res.data.type_list
      })
    },
    submitTransfer() {
      // eslint-disable-next-line eqeqeq
      if (this.form.event_type == '') {
        this.$message.error('请选择回传选项')
        return
      }
      for (const prop of this.selectedProperties) {
        const val = this.form.properties[prop.properties_key]
        if (!val) {
          this.$message.error(`${prop.properties_name} 不能为空!`)
          return
        }
      }
      oceanengineback({
        // event_type: this.selectedPlatform,
        ...this.form,
        open_id: this.open_id
      }).then((res) => {
        this.$message({
          message: '回传成功',
          type: 'success'
        })
        // this.selectedPlatform = null
        this.form = {
          event_type: '',
          properties: {}
        }
        this.selectedProperties = []
        this.typeList = []
        this.dialogTransferVisible = false
        this.menuListtwo()
      })
      console.log('selectedPlatform', this.selectedPlatform)
    },
    handleEventChange(eventType) {
      // 查找当前选中的事件类型对象
      const selected = this.typeList.find(item => item.event_type === eventType)

      // 重置属性
      this.selectedProperties = selected?.properties || []

      // 初始化表单里的 properties 字段（如果为空的话）
      this.form.properties = {}
      this.selectedProperties.forEach(prop => {
        this.$set(this.form.properties, prop.properties_key, '')
      })
    },
    formatCopy(row) {
      return `${row.title}
小程序：${row.account_name}${row.gh_id}
路径：${row.page_path}&user_action_set_id=${row.action_sets?.[0]?.user_action_set_id ?? ''}`
    },
    onCopysr() {
      this.$message.success('复制成功！')
    },
    onErrorsr() {
      this.$message.error('复制失败！')
    },
    srawoner() {
      this.objnum.page = 1
      this.neawrlist()
    },
    aweredoner() {
      this.objnum.page = 1
      this.objnum.iqiyi_promotion_link_no = ''
      this.objnum.app_id = ''
      this.dateRange = []
      this.neawrlist()
    },
    async neawrlist() {
      const params = {
        begin_date: this.dateRange?.[0] || '',
        end_date: this.dateRange?.[1] || ''
      }
      const data = await officialAccountpageDataStatisticslist({ ...params, ...this.objnum })
      this.newtablredata = data.data.list
      this.objtotal = data.data.total
      this.click_count = data.data.click_count
      console.log('data', data)
    },
    // 分页
    fetchPageSizerpoi(e) {
      this.objnum.pageSize = e
      this.neawrlist()
    },
    fetchCurrentPagerpoi(e) {
      this.objnum.page = e
      this.neawrlist()
    },
    lookdianji(iqiyi_promotion_link_no) {
      this.typelist = 4
      this.objnum.iqiyi_promotion_link_no = iqiyi_promotion_link_no
      this.neawrlist()
    },
    lookdata(item) {
      console.log(item)
      this.$router.push({
        path: '/miniprogramoption/miniprogramaccess',
        query: {
          appid: item.app_id,
          is_show: true
        }
      })
    },
    unBindStatusUpdate(val, item) {
      console.log(val, item)
      kiadwertwqw({
        iqiyi_promotion_link_no: item.iqiyi_promotion_link_no,
        default_a: val
      }).then((res) => {
        // eslint-disable-next-line eqeqeq
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.menuList()
        }
      })
    },
    openConfigDetail(row) {
      this.configSearch.app_id = row.app_id
      this.currentPagePath = row.page_path
      // 切换到数据源内推标签页
      this.typelist = 5
      this.loadConfigList()
    },
    // 获取 action_set 链接
    getActionSetLink(row, index) {
      if (!row.action_sets || !row.action_sets[index] || !row.page_path) {
        return ''
      }
      return `${row.page_path}&user_action_set_id=${row.action_sets[index].user_action_set_id}`
    },
    // 打开 action_sets 弹窗
    openActionSetsDialog(row) {
      this.currentActionSetsRow = row
      this.actionSetsPage = 1
      this.actionSetsDialogVisible = true
    },
    // 获取弹窗中的内推链接
    getActionSetLinkForDialog(actionSet) {
      if (!this.currentActionSetsRow || !this.currentActionSetsRow.page_path) {
        return ''
      }
      return `${this.currentActionSetsRow.page_path}&user_action_set_id=${actionSet.user_action_set_id}`
    },
    // action_sets 分页相关
    changeActionSetsPage(page) {
      this.actionSetsPage = page
    },
    changeActionSetsPageSize(size) {
      this.actionSetsPageSize = size
      this.actionSetsPage = 1
    },

    async loadConfigList() {
      this.globalLoading = true
      try {
        const res = await adDataSource(this.configSearch)
        this.configList = res.data.list
        this.configTotal = res.data.total
      } finally {
        this.globalLoading = false
      }
    },
    resetConfig() {
      this.configSearch.user_action_set_id = ''
      this.configSearch.page = 1
      this.loadConfigList()
    },
    resetConfigPage() {
      this.configSearch.app_id = ''
      this.configSearch.user_action_set_id = ''
      this.configSearch.page = 1
      this.currentPagePath = ''
      this.loadConfigList()
    },

    changeConfigPage(page) {
      this.configSearch.page = page
      this.loadConfigList()
    },
    changeConfigPageSize(size) {
      this.configSearch.pageSize = size
      this.loadConfigList()
    },

    // 同步弹窗逻辑
    openSyncDialog() {
      this.syncInput = ''
      this.syncDialogVisible = true
    },
    // 打开设置数据源（从推广链接页面跳转）
    openSetDataSource(row) {
      // 切换到数据源页面
      this.typelist = 5
      // 如果有 account_id，预填充到同步输入框
      if (row.account_id) {
        this.syncInput = row.account_id
      } else {
        this.syncInput = ''
      }
      // 打开同步数据源弹窗
      this.syncDialogVisible = true
      // 加载数据源列表
      this.$nextTick(() => {
        this.loadConfigList()
      })
    },
    closeSyncDialog() {
      this.syncInput = ''
      this.syncDialogVisible = false
    },
    async confirmSync() {
      if (!this.syncInput) {
        this.$message.error('account_id 不能为空')
        return
      }
      try {
        await syncData({ account_id: this.syncInput })
        this.$message.success('同步成功')
        this.closeSyncDialog()
        this.loadConfigList() // 同步成功后刷新父列表
      } catch (e) {
        this.$message.error('同步失败，请重试')
      }
    },

    // 更新SecretKey
    openUpdateSecret(row) {
      this.updateSecret = {
        account_id: row.account_id,
        user_action_set_id: row.user_action_set_id,
        secret_key: ''
      }
      this.updateSecretDialogVisible = true
    },
    closeUpdateSecret() {
      this.updateSecret = { account_id: '', user_action_set_id: '', secret_key: '' }
      this.updateSecretDialogVisible = false
    },
    async submitUpdateSecret() {
      if (!this.updateSecret.secret_key) {
        this.$message.error('SecretKey不能为空')
        return
      }
      await updateSecretKey(this.updateSecret)
      this.$message.success('更新成功')
      this.closeUpdateSecret()
      this.loadConfigList()
    },
    // 处理表格多选变化
    handleSelectionChange(selection) {
      this.multipleSelection = selection
    },
    // 批量删除方法（用户自己补充实现）
    handleBatchDelete() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要删除的数据')
        return
      }
      this.$confirm('确定要删除吗？', '提示').then(() => {
        // 从选中的对象数组中提取 iqiyi_promotion_link_no 值组成数组
        const iqiyiPromotionLinkNos = this.multipleSelection.map(item => item.iqiyi_promotion_link_no)
        iqiyipromotionlinkdel({
          iqiyi_promotion_link_nos: iqiyiPromotionLinkNos
        }).then(res => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.multipleSelection = [] // 清空选中项
          this.menuList()
        })
      })
    },
    // 处理是否默认开关变化
    handleHkDefaultChange(val, row) {
      // val是新值，计算旧值（1和2互转）
      const oldValue = val === 2 ? 1 : 2
      updateHkDefault({
        account_id: row.account_id,
        user_action_set_id: row.user_action_set_id,
        hk_default: val
      }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.loadConfigList()
        } else {
          // 如果失败，恢复原值
          this.$set(row, 'hk_default', oldValue)
        }
      }).catch(() => {
        // 如果失败，恢复原值
        this.$set(row, 'hk_default', oldValue)
        this.$message.error('操作失败，请重试')
      })
    },
    // 处理状态开关变化
    handleHkStatusChange(val, row) {
      // val是新值，计算旧值（1和2互转）
      // 1是打开，2是关闭
      const oldValue = val === 1 ? 2 : 1
      updateHkStatus({
        account_id: row.account_id,
        user_action_set_id: row.user_action_set_id,
        hk_status: val
      }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.loadConfigList()
        } else {
          // 如果失败，恢复原值
          this.$set(row, 'hk_status', oldValue)
        }
      }).catch(() => {
        // 如果失败，恢复原值
        this.$set(row, 'hk_status', oldValue)
        this.$message.error('操作失败，请重试')
      })
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
  display: flex;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.activer {
  color: red;
}
.activerno {
  color: #67c23a;
}
.employee-list {
  max-height: 3em; /* 大约两行的高度 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 控制最多显示2行 */
  -webkit-box-orient: vertical;
  cursor: pointer;
}

.employee-item {
  display: inline-block;
  margin-right: 8px;
}
/* .left_box{
  width: 150px;
  margin-right: 40px;
  flex-shrink: 0;
  border: 1px solid #ccc;
  padding: 20px;
}
.right_box{
  width: 1400px;
  width: 90%;
} */
 .left_box {
  width: 150px;
  margin-right: 40px;
  flex-shrink: 0;
  border: 1px solid #ccc;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.nav-btn {
  margin-bottom: 10px;
  padding: 8px 12px;
  text-align: center;
  background: #f5f7fa;
  border-radius: 4px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s;
}

.nav-btn:hover {
  background: #e6f0ff;
}

.nav-btn.active {
  background-color: #409EFF;
  color: #fff;
}

.tab-nav {
  display: flex;
  padding: 10px 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
}

.tab-item {
  margin-right: 30px;
  padding-bottom: 6px;
  font-size: 14px;
  color: #303133;
  cursor: pointer;
  position: relative;
}

.tab-item.active {
  color: #165dff;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #165dff;
  border-radius: 2px;
}
.right_box{
  width: 100%;
}
@media (max-width: 768px){
  .tab-item{
    font-size:3vw;
  }
}
</style>
